import React from 'react'
import { AssetRouteImport } from './Imports'
const { RoutesMap, AddGrn, AssetDetails, UpdateGrn, AssetLocation, AssetLocationDetails, GrnList, AddAssetIssue, AssetIssueList, AddToolsPartsTransfer, UpdateToolsPartsTransfer, ToolsPartsTransferList, AddToolsPartsReturn, ToolsPartsReturnList, AddInventory, GrnDetails, StockList, PendingAssetConversionList, AddStock, AddAmc, UpdateAmc, AmcList, AmcDetails, AssetList } = AssetRouteImport

const AssetRoute = () => {
    return [
        {
            path: RoutesMap.ADD_GRN.path,
            element: <AddGrn />
        },
        {
            path: RoutesMap.UPDATE_GRN.path,
            element: <UpdateGrn />
        },
        {
            path: RoutesMap.GRN_LIST.path,
            element: <GrnList />
        },
        {
            path: RoutesMap.ASSET_LIST.path,
            element: <AssetList />
        },
        {
            path: RoutesMap.STOCK_LIST.path,
            element: <StockList />
        },
        {
            path: RoutesMap.PENDING_ASSET_CONVERSION_LIST.path,
            element: <PendingAssetConversionList />
        },
        {
            path: RoutesMap.ADD_STOCK.path,
            element: <AddStock />
        },
        {
            path: RoutesMap.GRN_DETAILS.path,
            element: <GrnDetails />
        },


        {
            path: RoutesMap.ASSET_DETAILS.path,
            element: <AssetDetails />
        },

        {
            path: RoutesMap.ADD_ASSET_ISSUE.path,
            element: <AddAssetIssue />
        },
        // {
        //     path: RoutesMap.UPDATE_GRN.path,
        //     element: <UpdateGrn />
        // },
        {
            path: RoutesMap.ASSET_ISSUE_LIST.path,
            element: <AssetIssueList />
        },
        {
            path: RoutesMap.ADD_TOOLS_PARTS_TRANSFER.path,
            element: <AddToolsPartsTransfer />
        },
        {
            path: RoutesMap.UPDATE_TOOLS_PARTS_TRANSFER.path,
            element: <UpdateToolsPartsTransfer />
        },
        {
            path: RoutesMap.TOOLS_PARTS_TRANSFER_LIST.path,
            element: <ToolsPartsTransferList />
        },
        {
            path: RoutesMap.ADD_TOOLS_PARTS_RETURN.path,
            element: <AddToolsPartsReturn />
        },
        {
            path: RoutesMap.TOOLS_PARTS_RETURN_LIST.path,
            element: <ToolsPartsReturnList />
        },

        {
            path: RoutesMap.ASSET_LOCATION.path,
            element: <AssetLocation />
        },
        {
            path: RoutesMap.ASSET_LOCATION_DETAILS.path,
            element: <AssetLocationDetails />
        },
        {
            path: RoutesMap.ADD_INVENTORY.path,
            element: <AddInventory />
        },

        {
            path: RoutesMap.ADD_AMC.path,
            element: <AddAmc />
        },
        {
            path: RoutesMap.UPDATE_AMC.path,
            element: <UpdateAmc />
        },
        {
            path: RoutesMap.AMC_LIST.path,
            element: <AmcList />
        },
        {
            path: RoutesMap.AMC_DETAILS.path,
            element: <AmcDetails />
        },



    ]
}

export default AssetRoute;